let _companyId = null;

export function getCurrentCompanyId() {
  return _companyId;
}

export function setCurrentCompanyId(companyId) {
  _companyId = companyId;
}
